import React, { useMemo, useState } from 'react';
import '../schedule-pickups/index.css';
import moment from 'moment';
import Slots from './Slots';
const SLOT_COUNT = 8;

const SlotPickupsCalendar = ({
  currentWeek,
  setCurrentWeek,
  pickups,
  drivers,
  schedulePickup,
  assignDriverToPickup,
  selectedDriver,
  setSelectedDriver,
}) => {
  const [selectedDate, setSelectedDate] = useState(moment());

  const goPrevDay = () => {
    setSelectedDate((prev) => prev.clone().subtract(1, 'day'));
  };

  const goNextDay = () => {
    setSelectedDate((prev) => prev.clone().add(1, 'day'));
  };

  const driverPickups = useMemo(() => {
    if (!selectedDriver) return [];

    return pickups
      .filter((pickup) => {
        if (!pickup.scheduled_pickup_time) return false;

        return (
          pickup.driver?.id === Number(selectedDriver) &&
          moment(pickup.scheduled_pickup_time).isSame(selectedDate, 'day')
        );
      })
      .sort((a, b) =>
        moment(a.scheduled_pickup_time).diff(moment(b.scheduled_pickup_time)),
      );
  }, [pickups, selectedDriver, selectedDate]);

  return (
    <div
      className="card p-3"
      style={{
        flex: 1,
        borderRadius: 8,
        height: '78vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div className="d-flex justify-content-between align-items-center mb-4">
        <button className="btn btn-light border" onClick={goPrevDay}>
          <i className="fa fa-chevron-left" />
        </button>

        <h4 className="mb-0 fw-bold">{selectedDate.format('dddd, MMMM D')}</h4>

        <button className="btn btn-light border" onClick={goNextDay}>
          <i className="fa fa-chevron-right" />
        </button>
      </div>

      <div className="mb-4">
        {/* <label className="form-label fw-bold">Driver</label> */}

        <select
          className="form-control"
          value={selectedDriver}
          onChange={(e) => setSelectedDriver(e.target.value)}
        >
          <option value="">Select driver</option>

          {drivers.map((driver) => (
            <option key={driver.id} value={driver.id}>
              {driver.name}
            </option>
          ))}
        </select>
      </div>

      <div
        style={{
          flex: 1,
          overflowY: 'auto',
        }}
      >
        {Array.from({ length: SLOT_COUNT }).map((_, index) => {
          const pickup = driverPickups[index] || null;

          return (
            <Slots
              key={index}
              slot={index + 1}
              pickup={pickup}
              date={selectedDate}
              schedulePickup={schedulePickup}
              assignDriverToPickup={assignDriverToPickup}
            />
          );
        })}{' '}
      </div>
    </div>
  );
};

export default SlotPickupsCalendar;
